import { useAppSelector } from "@/hooks/redux";

import { PhotoList } from "./PhotoList";
import { ProgressLoading } from "./ProgressLoading";

export const PhotoUpload = () => {
    const { progress } = useAppSelector(
        (state) => state.offline.photoUploadRetry,
    );

    const { isRunning, completedCount, totalCount } = progress;

    return isRunning ? (
        <ProgressLoading
            completedCount={completedCount}
            totalCount={totalCount}
        />
    ) : (
        <PhotoList />
    );
};
